import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUnlockAlt, faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  Form,
  Card,
  Col,
  InputGroup,
  Button,
  Row,
  Spinner,
} from "@themesberg/react-bootstrap";
import {
  tenDigitRegexStartingWith9,
  EMAIL_REGEX,
} from "../../helpers/regexHelper";
import {
  clearSahakariMainBranch,
  createSahakari,
  getSahakariMainBranch,
} from "../../redux/actions/sahakari";
import DateFormatHelper from "../../helpers/DateFormatHelper";
import CustomDashboardLoader from "../../components/CustomDashboardLoader";

const initialErrors = {
  errorName: "",
  errorEmail: "",
  errorUsername: "",
  errorPassword: "",
  errorPhone: "",
  errorAddress: "",
  errorExpiresDate: "",
  errorSahakariBranch: "",
};
const initialValues = {
  name: "",
  email: "",
  username: "",
  password: "",
  phone: "",
  address: "",
  sahakariBranch: "",
};

const tempArray = [
  {
    id: 11,
    name: "sahakari11",
    isActive: false,
    expirationDate: "2022-08-16",
    location: "Kuleshwor",
    contactNumber: "010102020303",
    mainBranch: "SELF",
  },
  {
    id: 8,
    name: "sahakari8",
    isActive: true,
    expirationDate: "2021-08-17",
    location: "Kuleshwor",
    contactNumber: null,
    mainBranch: "SELF",
  },
];

function AddSahakari() {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [expiresDate, setExpiresDate] = useState("");
  const [values, setValues] = useState(initialValues);
  const [isMainSahakari, setIsMainSahakari] = useState(true);
  const [errors, setErrors] = useState(initialErrors);
  const sahakariMainBranchData = useSelector(
    (state) => state.sahakari.sahakariMainBranch
  );

  const { name, email, username, password, phone, address, sahakariBranch } =
    values;
  const {
    errorName,
    errorEmail,
    errorUsername,
    errorPassword,
    errorPhone,
    errorAddress,
    errorExpiresDate,
    errorSahakariBranch,
  } = errors;

  useEffect(() => {
    setIsLoading(true);
    dispatch(getSahakariMainBranch()).then(() => setIsLoading(false));

    return () => {
      dispatch(clearSahakariMainBranch());
    };
  }, []);

  const handleSuccess = () => {
    setValues(initialValues);
    setExpiresDate("");
    setIsSubmitting(false);
    toast.success("Sahakari has successfully been created");
  };
  const handleFaliure = (e) => {
    // alert("Login failed");
    toast.error(e.response ? e.response.data.message : e.message);
    setIsSubmitting(false);
  };

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const errorHandler = (key, val) => {
    setErrors((current) => {
      return { ...current, [key]: val };
    });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    let hasErrors = false;
    if (!/\S/.test(name)) {
      hasErrors = true;
      errorHandler("errorName", "Name cannot be empty");
    } else {
      errorHandler("errorName", "");
    }
    if (!/\S/.test(email)) {
      hasErrors = true;
      errorHandler("errorEmail", "Email cannot be empty");
    } else if (!EMAIL_REGEX.test(email)) {
      hasErrors = true;
      errorHandler("errorEmail", "Enter a valid email");
    } else {
      errorHandler("errorEmail", "");
    }
    if (!/\S/.test(username)) {
      hasErrors = true;
      errorHandler("errorUsername", "Username cannot be empty");
    } else {
      errorHandler("errorUsername", "");
    }
    if (!/\S/.test(password)) {
      hasErrors = true;
      errorHandler("errorPassword", "Password cannot be empty");
    } else if (password.length < 6) {
      hasErrors = true;
      errorHandler(
        "errorPassword",
        "Password should be minimum of 6 characters long"
      );
    } else {
      errorHandler("errorPassword", "");
    }
    if (!/\S/.test(phone)) {
      hasErrors = true;
      errorHandler("errorPhone", "Phone cannot be empty");
    } else if (!tenDigitRegexStartingWith9.test(phone)) {
      hasErrors = true;
      errorHandler(
        "errorPhone",
        "Phone should be of 10 digits starting with 9"
      );
    } else {
      errorHandler("errorPhone", "");
    }
    if (!/\S/.test(address)) {
      hasErrors = true;
      errorHandler("errorAddress", "Address cannot be empty");
    } else {
      errorHandler("errorAddress", "");
    }
    if (!/\S/.test(expiresDate)) {
      hasErrors = true;
      errorHandler("errorExpiresDate", "Subscription Date cannot be empty");
    } else {
      errorHandler("errorExpiresDate", "");
    }

    if (!isMainSahakari) {
      if (!/\S/.test(sahakariBranch)) {
        hasErrors = true;
        errorHandler("errorSahakariBranch", "Please select a sahakari branch");
      } else {
        errorHandler("errorSahakariBranch", "");
      }
    } else {
      errorHandler("errorSahakariBranch", "");
    }

    if (hasErrors) {
      toast.error("Please check all the form fields");
    } else {
      setErrors(initialErrors);
      setIsSubmitting(true);
      const expirationDateString = moment(expiresDate).format("YYYY/MM/DD");
      //todo
      const sahakariMainBranch = isMainSahakari ? "SELF" : sahakariBranch;
      const data = {
        sahakariName: name,
        isActive: true,
        expirationDate: DateFormatHelper(expirationDateString),
        adminName: name,
        adminUsername: username,
        adminPassword: password,
        adminMobileNumber: phone,
        adminEmail: email,
        sahakariLocation: address,
        sahakariMainBranch,
      };
      dispatch(createSahakari(data, handleSuccess, handleFaliure));
    }
  };

  return (
    <Col md={12} className={"mt-3"}>
      {isLoading ? (
        <CustomDashboardLoader />
      ) : (
        <>
          <Card border="light" className="bg-white shadow-sm mb-4 p-0">
            <Card.Body>
              <h5 className="mb-4">Create a Sahakari Account</h5>

              <Form noValidate onSubmit={submitHandler}>
                <Row>
                  <Col md={6} className="mb-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="name"
                        value={name}
                        // placeholder="sahakari name"
                        onChange={onChange}
                      />
                      {errorName !== "" && (
                        <Form.Text className="text-danger">
                          {errorName}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6} className="mb-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Email address</Form.Label>
                      <Form.Control
                        required
                        type="email"
                        name="email"
                        value={email}
                        // placeholder="name@example.com"
                        onChange={onChange}
                      />
                      {errorEmail !== "" && (
                        <Form.Text className="text-danger">
                          {errorEmail}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6} className="mb-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Username</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="username"
                        value={username}
                        // placeholder="username"
                        onChange={onChange}
                      />
                      {errorUsername !== "" && (
                        <Form.Text className="text-danger">
                          {errorUsername}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6} className="mb-3">
                    <Form.Group id="password" className="mb-4">
                      <Form.Label>Password</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUnlockAlt} />
                        </InputGroup.Text>
                        <Form.Control
                          required
                          name="password"
                          type="password"
                          value={password}
                          // placeholder="Password"
                          onChange={onChange}
                        />
                      </InputGroup>
                      {errorPassword !== "" && (
                        <Form.Text className="text-danger">
                          {errorPassword}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6} className="mb-3">
                    <Form.Group id="phone">
                      <Form.Label>Phone</Form.Label>
                      <Form.Control
                        name="phone"
                        required
                        type="number"
                        value={phone}
                        // placeholder="98XXXXXXXX"
                        onChange={onChange}
                      />
                      {errorPhone !== "" && (
                        <Form.Text className="text-danger">
                          {errorPhone}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6} className="mb-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        name="address"
                        type="text"
                        value={address}
                        // placeholder="Address"
                        onChange={onChange}
                      />
                      {errorAddress !== "" && (
                        <Form.Text className="text-danger">
                          {errorAddress}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6} className="mb-3">
                    <Form.Group id="sahakariType">
                      <Form.Label>Sahakari Type : </Form.Label>
                      <br />
                      <Form.Check
                        inline
                        label="Main Office"
                        name="sahakariGroupType"
                        type={"radio"}
                        onClick={() => setIsMainSahakari(true)}
                        checked={isMainSahakari}
                      />
                      <Form.Check
                        inline
                        label="Branch"
                        name="sahakariGroupType"
                        type={"radio"}
                        checked={!isMainSahakari}
                        onClick={() => setIsMainSahakari(false)}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6} className="mb-3">
                    <Form.Group id="expiresdate">
                      <Form.Label>Subscription until:</Form.Label>
                      <Datetime
                        timeFormat={false}
                        name="expirationDate"
                        onChange={setExpiresDate}
                        renderInput={(props, openCalendar) => (
                          <InputGroup>
                            <InputGroup.Text>
                              <FontAwesomeIcon icon={faCalendarAlt} />
                            </InputGroup.Text>
                            <Form.Control
                              required
                              type="text"
                              value={
                                expiresDate
                                  ? moment(expiresDate).format("YYYY/MM/DD")
                                  : ""
                              }
                              placeholder="YYYY/MM/DD"
                              onFocus={openCalendar}
                              onChange={() => {}}
                            />
                          </InputGroup>
                        )}
                      />
                      {errorExpiresDate !== "" && (
                        <Form.Text className="text-danger">
                          {errorExpiresDate}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6} className="mb-3">
                    {!isMainSahakari && (
                      <Form.Group className="mb-3">
                        <Form.Label>Select Main Branch</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          value={sahakariBranch}
                          onChange={(e) =>
                            setValues({
                              ...values,
                              sahakariBranch: e.target.value,
                            })
                          }
                        >
                          <option value={null}>{null}</option>
                          {sahakariMainBranchData.map((item) => (
                            <option value={item.name} key={item.id}>
                              {item.name} - ({item.location})
                            </option>
                          ))}
                        </Form.Select>
                        {errorSahakariBranch !== "" && (
                          <Form.Text className="text-danger">
                            {errorSahakariBranch}
                          </Form.Text>
                        )}
                      </Form.Group>
                    )}
                  </Col>
                </Row>
                <div className="d-flex justify-content-end">
                  <Button
                    type="submit"
                    variant="primary"
                    className="m-1"
                    onClick={submitHandler}
                    disabled={isSubmitting}
                  >
                    {isSubmitting === true ? (
                      <Spinner animation="border" />
                    ) : (
                      "Create Sahakari"
                    )}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </>
      )}
    </Col>
  );
}

export default AddSahakari;
